<template>
  <div id="onboarding-frontdoc" class="fade-in">
    <StepInfo btnText="Tirar foto" @btnClick="actionEvent">
      <h2>Olá, <span>{{name | capitalize({ first: true })}}</span></h2>
      <p>
        Para seguir com seu cadastro no Parcelex precisamos da foto do seu
        <b>RG</b> ou <b>CNH</b>.
      </p>

      <div class="onboarding-image">
        <Asset
          name="frontdoc.svg"
          alt="Frente do documento"
          title="Frente do documento"
        />

        <p><b> Com a CNH a verificação é mais rápida.</b></p>
      </div>
    </StepInfo>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Asset from '@/components/common/Asset.vue';
import StepInfo from '../components/StepInfo.vue';
import StringMixing from '../../../mixins/string';

export default {
  name: 'onboarding-frontdoc',
  components: { StepInfo, Asset },
  mixins: [StringMixing],
  computed: {
    ...mapState('onboarding', ['name']),
  },
  methods: {
    actionEvent() {
      this.$router.replace({
        name: 'onboarding-frontdoc-camera',
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #onboarding-frontdoc {
    h2 {
      color: var(--gray-600);
      margin-top: 24px;

      span {
        @extend .primary;
      }
    }

    p {
      @extend .lead;
      margin: 16px 0px;
      line-height: 26px;

      & + p {
        @extend .lead-semibold;
        margin-bottom: 36px;
      }
    }

    .onboarding-image {
      text-align: center;
    }
  }
</style>
